
import { useState, useEffect } from 'react';

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.1 }
    );

    const element = document.getElementById('faq');
    if (element) {
      observer.observe(element);
    }

    return () => observer.disconnect();
  }, []);

  const faqs = [
    {
      question: 'Qual é o diferencial da Contabilidade Renzi Rossi?',
      answer: 'Aqui, cada cliente é tratado com atenção de verdade. Somos uma contabilidade que ouve, entende e acompanha de perto o crescimento do seu negócio.'
    },
    {
      question: 'Vocês atendem empresas de que porte?',
      answer: 'Atendemos empresas de todos os portes, desde MEs até grandes empresas. Nossos serviços são personalizados conforme as necessidades específicas de cada cliente.'
    },
    {
      question: 'Como funciona o processo de contratação?',
      answer: 'O processo é simples: primeiro fazemos um diagnóstico gratuito da sua situação, depois elaboramos um plano personalizado e, por fim, executamos os serviços com acompanhamento constante.'
    },
    {
      question: 'Vocês cumprem todos os prazos legais?',
      answer: 'Sim, a pontualidade é um dos nossos valores fundamentais. Temos controles rigorosos para garantir que todas as obrigações sejam cumpridas dentro dos prazos estabelecidos.'
    },
    {
      question: 'Como é feito o acompanhamento dos serviços?',
      answer: 'Mantemos comunicação constante através de relatórios regulares, reuniões periódicas e disponibilidade total para esclarecimentos. Você sempre saberá o que está acontecendo.'
    },
    {
      question: 'Vocês oferecem consultoria além dos serviços básicos?',
      answer: 'Sim, oferecemos consultoria empresarial completa, incluindo planejamento tributário, BPO financeiro e orientações estratégicas para o crescimento do seu negócio.'
    }
  ];

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section id="faq" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-800 mb-4" style={{ fontFamily: 'DM Sans, sans-serif' }}>
            Perguntas Frequentes
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Esclarecemos as principais dúvidas sobre nossos serviços
          </p>
        </div>

        <div className="max-w-4xl mx-auto">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className={`mb-4 transform transition-all duration-700 ${
                isVisible 
                  ? 'translate-y-0 opacity-100' 
                  : 'translate-y-10 opacity-0'
              }`}
              style={{ transitionDelay: `${index * 100}ms` }}
            >
              <div className="bg-white border border-gray-200 rounded-xl shadow-sm hover:shadow-md transition-shadow duration-200">
                <button
                  onClick={() => toggleFAQ(index)}
                  className="w-full px-6 py-4 text-left flex items-center justify-between focus:outline-none"
                >
                  <h3 className="text-lg font-semibold text-gray-800 pr-4" style={{ fontFamily: 'DM Sans, sans-serif' }}>
                    {faq.question}
                  </h3>
                  <i className={`ri-arrow-${openIndex === index ? 'up' : 'down'}-s-line text-blue-600 text-xl transition-transform duration-200`}></i>
                </button>
                
                <div className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
                }`}>
                  <div className="px-6 pb-4">
                    <p className="text-gray-600 leading-relaxed">
                      {faq.answer}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
